<div class="col-sm-2 amenities-filter">
    <div class="amenities-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="amenities-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="approvedCheckbox" #approvedCheckbox (change)="changeFilter()">
                <label for="approvedCheckbox"><svg-checked></svg-checked></label>
                <span>Approved</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pendingCheckbox" #pendingCheckbox (change)="changeFilter()">
                <label for="pendingCheckbox"><svg-checked></svg-checked></label>
                <span>Pending</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="expiredCheckbox" #expiredCheckbox (change)="changeFilter()">
                <label for="expiredCheckbox"><svg-checked></svg-checked></label>
                <span>Expired</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="declinedCheckbox" #declinedCheckbox (change)="changeFilter()">
                <label for="declinedCheckbox"><svg-checked></svg-checked></label>
                <span>Declined</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/maintenance-calendar-filter/maintenance-calendar-filter.component.html